/** Derives golden-row author from Auth0 email local-part or display name. */
export function deriveGoldenRowAuthor(reviewerIdentity: string): string {
  if (!reviewerIdentity) {
    return "";
  }

  const atIndex = reviewerIdentity.indexOf("@");
  if (atIndex > 0) {
    return reviewerIdentity.slice(0, atIndex);
  }

  return reviewerIdentity;
}
